import styled, { css } from 'styled-components';
import { Loader as LoaderComponent } from 'src/components';

export const Loader = styled(LoaderComponent)(
  ({ theme }) => css`
    height: ${theme.sz.s16};
    margin: auto;
    display: block;
  `,
);
